module.exports = __webpack_public_path__ + "static/media/DS_Membership_Pic1.774f76df.png";